import axios from "axios";

export const inhouse = {
    namespaced: true,
    state: {
        data:[],
        dialog:false,
        title:"",
        total:0,
        connectionError:null,
        ErrorMessage:null,
    },
    mutations: {
        setData(state,val){
            state.data = val;
        },
        setTitle(state,val){
            state.title = val;
        },
        setTotal(state,val){
            state.total = val;
        },
        setError(state,val){
            state.connectionError = val;
        },
        setErrorMessage(state,val){
            state.ErrorMessage = val;
        },
        ShowDialog(state,val){
            state.dialog = val
        }
    },
    actions: {
        GetData({commit,dispatch},row){
            commit("setData",[])
            dispatch("loading",true,{root:true})
            let place = row;
            axios.post('https://windows.moowifi.com.tr/includes/UserList.php?list=inhousnew', { place })
                .then((res) => {

                    if(res.data.error){
                        let connectionError = `
                        <b>IP Port :</b> ${res.data.ip},${res.data.port} <br /> 
                        <b>Database:</b> ${res.data.database}<br />
                        <b>Username:</b> ${res.data.username}<br />
                        <b>Password:</b> ${res.data.password}<br />`
                        commit("setError", connectionError)
                        commit("setErrorMessage", res.data.message)

                    }else{
                        commit("setError", null);
                        commit("setData",res.data);
                        commit("setTitle", row.P_Header);
                        commit("setTotal", res.data.length);
                    }
                    commit("setTitle", row.P_Header)
                    commit("ShowDialog", true);
                    dispatch("loading",false,{root:true})
                }).catch((e) => {
                console.log(e);
                dispatch("loading",false,{root:true})
            })


        },
    },
}